// Angular
// https://angular.io/
import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

// Angular Material
// https://material.angular.io/
import {
	MdAutocompleteModule,
	MdButtonModule,
	MdButtonToggleModule,
	MdCardModule,
	MdCheckboxModule,
	MdChipsModule,
	MdDatepickerModule,
	MdDialogModule,
	MdExpansionModule,
	MdGridListModule,
	MdIconModule,
	MdInputModule,
	MdListModule,
	MdMenuModule,
	MdNativeDateModule,
	MdProgressBarModule,
	MdProgressSpinnerModule,
	MdRadioModule,
	MdRippleModule,
	MdSelectModule,
	MdSidenavModule,
	MdSliderModule,
	MdSlideToggleModule,
	MdSnackBarModule,
	MdTabsModule,
	MdToolbarModule,
	MdTooltipModule,
	StyleModule,
	DateAdapter
} from "@angular/material";
import { NguUtilityModule } from "ngu-utility/ngu-utility.module";
import { MalihuScrollbarModule } from "ngx-malihu-scrollbar";
// ngx-bootstrap4
// http://valor-software.com/ngx-bootstrap/index-bs4.html#/
import { TabsModule } from "ngx-bootstrap/tabs";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { AlertModule } from "ngx-bootstrap/alert";
import { ModalModule } from "ngx-bootstrap/modal";
import { PopoverModule } from "ngx-bootstrap/popover";
import { NgDatepickerModule } from 'ng2-datepicker';

// UI Shared Components
import { FooterComponent } from "../layout/footer/footer.component";
import { AppBackdropComponent } from "./components/app_backdrop/app_backdrop.component";

import {
	SmdFabSpeedDialActionsComponent,
	SmdFabSpeedDialComponent,
	SmdFabSpeedDialTriggerComponent
} from "./components/fab/index";
import { ImageCardComponent } from "app/shared/components/cards/image-card/image-card.component";
import { ImageOverCardComponent } from "app/shared/components/cards/image-over-card/image-over-card.component";
import { GalleryCardComponent } from "app/shared/components/cards/gallery-card/gallery-card.component";
import { ListCardComponent } from "app/shared/components/cards/list-card/list-card.component";
import { MailCardComponent } from "app/shared/components/cards/mail-card/mail-card.component";
import { ScheduleCardComponent } from "app/shared/components/cards/schedule-card/schedule-card.component";
import { SocialCardComponent } from "app/shared/components/cards/social-card/social-card.component";
import { ScrumCardComponent } from "app/shared/components/cards/scrum-card/scrum-card.component";
import { StackedCardsComponent } from "app/shared/components/cards/stacked-cards/stacked-cards.component";
import { TabsOverCardComponent } from "app/shared/components/cards/tabs-over-card/tabs-over-card.component";
import { WeatherCardComponent } from "app/shared/components/cards/weather-card/weather-card.component";
import { MAT_DATE_LOCALE } from '@angular/material';
import { CustomDateAdapter } from "app/adapters/custom-data-adapter";
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MdCardModule,		
		MdAutocompleteModule,
		MdButtonModule,
		MdButtonToggleModule,
		MdCheckboxModule,
		MdChipsModule,
		MdDatepickerModule,
		MdDialogModule,
		MdExpansionModule,
		MdGridListModule,
		MdIconModule,
		MdInputModule,
		MdListModule,
		MdMenuModule,
		MdNativeDateModule,
		MdProgressBarModule,
		MdProgressSpinnerModule,
		MdRadioModule,
		MdRippleModule,
		MdSelectModule,
		MdSidenavModule,
		MdSliderModule,
		MdSlideToggleModule,
		MdSnackBarModule,
		MdTabsModule,
		MdToolbarModule,
		MdTooltipModule,
		StyleModule,
		NguUtilityModule,
		BsDropdownModule.forRoot(),
		AlertModule.forRoot(),
		TabsModule.forRoot(),
		MalihuScrollbarModule.forRoot(),
		ModalModule.forRoot(),
		PopoverModule.forRoot(),
		NgDatepickerModule,
		Ng2DeviceDetectorModule
	],
	declarations: [
		AppBackdropComponent,
		FooterComponent,
		SmdFabSpeedDialActionsComponent,
		SmdFabSpeedDialComponent,
		SmdFabSpeedDialTriggerComponent,
		ImageCardComponent,
		ImageOverCardComponent,
		GalleryCardComponent,
		ListCardComponent,
		MailCardComponent,
		ScheduleCardComponent,
		ScrumCardComponent,
		SocialCardComponent,
		StackedCardsComponent,
		TabsOverCardComponent,
		WeatherCardComponent
	],
	exports: [
		CommonModule,
		FormsModule,
		MdButtonToggleModule,
		MdCheckboxModule,
		MdRadioModule,
		MdSidenavModule,
		StyleModule,
		NguUtilityModule,
		AppBackdropComponent,
		ReactiveFormsModule,
		TabsModule,
		BsDropdownModule,
		AlertModule,
		MalihuScrollbarModule,
		ModalModule,
		PopoverModule,
		MdAutocompleteModule,
		MdButtonModule,
		MdButtonToggleModule,
		MdCardModule,
		MdChipsModule,
		MdDatepickerModule,
		MdDialogModule,
		MdExpansionModule,
		MdGridListModule,
		MdIconModule,
		MdInputModule,
		MdListModule,
		MdMenuModule,
		MdNativeDateModule,
		MdProgressBarModule,
		MdProgressSpinnerModule,
		MdRippleModule,
		MdSelectModule,
		MdSliderModule,
		MdSlideToggleModule,
		MdSnackBarModule,
		MdTabsModule,
		MdToolbarModule,
		MdTooltipModule,
		SmdFabSpeedDialActionsComponent,
		SmdFabSpeedDialComponent,
		SmdFabSpeedDialTriggerComponent,
		NgDatepickerModule,
		Ng2DeviceDetectorModule
	],
	providers:[
		{ provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
		{provide: DateAdapter, useClass: CustomDateAdapter }
	]
})
export class SharedModule {
	static forRoot(): ModuleWithProviders {
		return {
			ngModule: SharedModule
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts